import(/* webpackMode: "eager", webpackExports: ["AssignGradeAutoView"] */ "/web/src/sections/sub-pages/lms/assign-grade-auto/views/assign-grade-auto-view.tsx");
